// must match EnumDbType.java
export const MYSQL = 'mysql';
export const POSTGRES = 'postgres';
export const REDSHIFT = 'redshift';
export const SQLSERVER = 'sqlserver';
export const SNOWFLAKE = 'snowflake';
export const BIGQUERY = 'bigquery';
